import { api, writeDB } from './store';
import { picklistPath, picklistsPath } from '../routes';
import { history } from './history';
import { PaginatedLoaderResponse, paginatedLoaderResponseFrom } from './data';

/* INTERFACES */
export interface PicklistBase {
  batchSize?: number;
  reference?: string;
  createdAt?: Date;
  updatedAt?: Date;
  deliveryIds?: string[];
  pdfUrl?: string;
  addressesCsvDownloadUrl?: string;
  ticketlistPdfUrl?: string;
}

export interface Picklist extends PicklistBase {
  id: string;
  containsPicklist: boolean;
  containsTicketlist: boolean;
  containsDeliveries: boolean;
  $permissions: string[];
}

export interface PicklistPatch extends PicklistBase {
  containsPicklist: boolean;
  containsTicketlist: boolean;
  containsDeliveries: boolean;
}

/* PICKLISTS CREATE */
export async function createPicklist(options: PicklistPatch): Promise<void> {
  const response = await api.createPicklist(options);
  writeDB.table('picklists').insert(response.data);
  if (response.data.id) {
    history.push(picklistPath(response.data.id));
  }
}

/* PICKLISTS READ */
export async function getPicklists({
  page,
  perPage,
  sortBy = 'created_at',
  sortDir = 'desc',
}: {
  page?: number;
  perPage?: number;
  sortBy?: string;
  sortDir?: string;
}): Promise<PaginatedLoaderResponse> {
  const response = await api.indexPicklists({
    page: (page || 0) + 1,
    perPage,
    sortBy,
    sortDir,
  });
  const picklist = response.data as unknown as Picklist[];
  writeDB.table('picklists').upsert(picklist);
  return paginatedLoaderResponseFrom(response);
}

export async function getPicklist(picklistId: string): Promise<Picklist> {
  const picklist = (await api.showPicklist({ picklistId })).data;
  writeDB.table('picklists').upsert(picklist);
  return picklist as Picklist;
}

/* PICKLIST DELETE */
export async function deletePicklist({ picklistId }: { picklistId: string }): Promise<void> {
  await api.destroyPicklist({ picklistId });
  writeDB.table('picklists').delete(picklistId);
  history.push(picklistsPath());
}
